<div *transloco="let t; read: TRANSLATION_SCOPE" class="booking-content mb-2 mt-2">
  <div class="d-flex row justify-content-between mt-2">
    <div class="col-4 booking-content__price-details">
      <div class="row ml-2">
        <span class="label">{{
          t('total')
        }}</span>
      </div>
      <div class="row ml-2">
        <span *ngIf="(currency$ | async) as currency" class="price">
          {{ totalPrice | rxCurrency: currency:'symbol':formatDecimals }}
        </span>
      </div>
    </div>
    <div class="col-4 align-self-center">
      <div class="row booking-content__book-button">
        <rx-button
          buttonClass="primary"
          [disabled]="disableButton"
          (click)="clickButton.emit()"
        >
          {{ t('bookNow') }}
        </rx-button>
      </div>
    </div>
    <div class="col-4">&nbsp;</div>
  </div>
  <div class="row justify-content-around mt-2">
    <span class="booking-content__tcs">{{
      t('noExtraCharges')
    }}</span>
  </div>
</div>
